<template>
  <sl-side-panel v-model="visible" :mask-closable="false" :title="itemTitle">
    <Row :gutter="12">
      <Col span="24" v-for="item in avalidFields" :key="item.key">
        <sl-label :label-width="120" :title="item.label" :content="data[item.key]" />
      </Col>
    </Row>
  </sl-side-panel>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      fields: [
        { key: 'stateText', label: '审批状态' },

        { key: 'enterpriseName', label: '企业名称' ,condition:data=>!!data.enterpriseCode},
        { key: 'personalName', label: '姓名' , condition:data=>!!data.personalId},
        { key: 'enterpriseCode', label: '统一信用代码', condition:data=>!!data.enterpriseCode },
        { key: 'personalCode', label: '身份证号' ,condition:data=>!!data.personalId},

        { key: 'creditCompanyName', label: '授信公司' },

        { key: 'amount', label: '贷款金额' },
        { key: 'realLoanAmount', label: '实际贷款金额' },
        { key: 'firstPayAmount', label: '首月月还' },
        { key: 'monthlyPayFinalAmount', label: '每期月还' },
        { key: 'financeFee', label: '金融服务费' },
        { key: 'bankFee', label: '银行手续费' },
        { key: 'guaranteeAmount', label: '贷款担保额' },
        { key: 'monthlyPayAmount', label: '月还初步' },
      ],
      data: {}
    }
  },

  computed: {
    itemTitle() {
      return '查看贷款信息'
    },
    avalidFields(){
      return this.fields.filter( i =>  i.condition ? i.condition(this.data) : true )
    }
  },
  methods: {
    init(id) {
      this.visible = true
      this.$request.ciLoan(id).then(resp => {
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data, { 'state': '$loanState' })
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },

  }
}

</script>
